import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { THEME_REGISTRY } from './organisationTheme';

const getUiTheme = (state: any) => state.uiTheme || {};

const getCurrentTheme = (state: any) => state.uiTheme?.currentTheme || 'light';

export const getTheme = createSelector(
  [getUiTheme, getCurrentTheme],
  (legacyTheme, currentTheme) => {
    const resolveDesignTokens = THEME_REGISTRY[currentTheme] || THEME_REGISTRY.light;

    return {
      ...legacyTheme, // All existing colors, sizes, fonts
      ...resolveDesignTokens(), // New design tokens: color, spacing, typography, radius
    };
  },
);

const mapStateToProps = (state) => ({
  theme: getTheme(state),
});

const connectTheme = (component) => connect(mapStateToProps)(component);

export default connectTheme;
